import { OkIcon, NoIcon } from "../../../../src/components/Icons";
import "../../../../src/styles/prereq.css";
import * as React from 'react';
export default {
  OkIcon,
  NoIcon,
  React
};